import React, {useState} from 'react'
import cn from 'classnames'
import {useSelector} from 'react-redux'
import {tagsSidebarSelector} from '../selectors'
import TagList from './TagList'
import dictionary from '../../../dictionary'
import trackEvent from '../../../utils/track-event'
import Tag from './Tag'
import OwnDesignBtn from './OwnDesignBtn'
import Categories from './Filters/Categories'
import SortBy from './Filters/SortBy'

/** @param {import('./Sidebar').SidebarProps} props */
export default function Sidebar(props) {
    const [isOpen, setIsOpen] = useState(false)

    const tags = useSelector(tagsSidebarSelector)

    const openTags = () => {
        setIsOpen(true)
        trackEvent({
            category: 'store button',
            action: 'Button show more click',
        })
    }

    const track = (tagName) => () => {
        trackEvent({
            category: 'store button',
            action: 'left sidebar click',
            label: tagName,
        })
    }

    const {
        withChildren = false,
        isCustomStore = false,
        filters,
        sort,
        categories,
    } = props

    return (
        <If condition={tags}>
            <div className="sidebar">
                <OwnDesignBtn />
                <If condition={isCustomStore}>
                    <div
                        className={cn('filters', 'for-hint', 'clearfix', {
                            ['filters_custom-store']: isCustomStore,
                        })}
                        data-testid="customStoreSidebar"
                    >
                        <Categories
                            categories={categories}
                            isCustomStore={isCustomStore}
                            filters={filters}
                        />
                        <SortBy sort={sort} isSelect={true} filters={filters} />
                    </div>
                </If>
                <If condition={!isCustomStore}>
                    <div className="sidebar__content">
                        <div className="tag-list">
                            <div className="tag-list__featured">
                                <TagList
                                    tags={tags.featured}
                                    withoutContainer={true}
                                    withChildren={withChildren}
                                    tagClick={track}
                                />
                            </div>
                            <div>
                                <TagList
                                    tags={tags.normal}
                                    withoutContainer={true}
                                    withChildren={withChildren}
                                    tagClick={track}
                                />
                            </div>
                            <If condition={isOpen}>
                                <div>
                                    <TagList
                                        tags={tags.hidden}
                                        withoutContainer={true}
                                        withChildren={withChildren}
                                        tagClick={track}
                                    />
                                    <div className="tag-list__item">
                                        <Tag
                                            tag={{
                                                name: 'Новинки',
                                                path: '/store/novelty',
                                                parametrazedName: 'novelty',
                                            }}
                                            handleClick={track}
                                        />
                                    </div>
                                </div>
                            </If>
                            <If
                                condition={
                                    !isOpen && tags.hidden && tags.hidden.length
                                }
                            >
                                <div
                                    className="b-btn b-btn_small"
                                    onClick={openTags}
                                >
                                    <span>{dictionary.store.Show_more}</span>
                                </div>
                            </If>
                        </div>
                    </div>
                </If>
            </div>
        </If>
    )
}
